import { useEffect, useState } from 'react';

interface UseParticipantIdReturn {
  participantId: string | null;
  setParticipantId: (id: string) => void;
  clearParticipantId: () => void;
  hasParticipantId: boolean;
}

export const useParticipantId = (): UseParticipantIdReturn => {
  const [participantId, setParticipantIdState] = useState<string | null>(null);
  
  // Função para limpar aspas extras do participantId
  const cleanParticipantId = (id: string): string => {
    if (!id) return id;
    
    // Remove aspas extras se existirem
    let cleanId = id;
    
    // Se começar e terminar com aspas, remover
    if (cleanId.startsWith('"') && cleanId.endsWith('"')) {
      cleanId = cleanId.slice(1, -1);
    }
    
    // Se ainda tiver aspas escapadas, tentar fazer parse
    if (cleanId.includes('\\"')) {
      try {
        cleanId = JSON.parse(`"${cleanId}"`);
      } catch {
        // Se não conseguir fazer parse, remover aspas manualmente
        cleanId = cleanId.replace(/\\"/g, '');
      }
    }
    
    return cleanId;
  };
  
  useEffect(() => {
    const storedId = localStorage.getItem('@pwa-participantId');
    
    if (storedId) {
      try {
        // Tentar fazer parse JSON primeiro
        const parsed = JSON.parse(storedId);
        const cleanId = cleanParticipantId(parsed);
        setParticipantIdState(cleanId);
      } catch {
        // Se não conseguir fazer parse, limpar e usar o valor
        const cleanId = cleanParticipantId(storedId);
        setParticipantIdState(cleanId);
      }
    }
  }, []);
  
  const setParticipantId = (id: string) => {
    // Limpar o ID antes de salvar
    const cleanId = cleanParticipantId(id);
    
    console.log('Setting participantId:', {
      original: id,
      cleaned: cleanId
    });
    
    // Salvar como string simples, não JSON
    localStorage.setItem('@pwa-participantId', cleanId);
    setParticipantIdState(cleanId);
  };
  
  const clearParticipantId = () => {
    localStorage.removeItem('@pwa-participantId');
    setParticipantIdState(null);
  };
  
  const hasParticipantId = !!participantId;
  
  return {
    participantId,
    setParticipantId,
    clearParticipantId,
    hasParticipantId
  };
};
